<button (click)="toggleThemeMode()" class="theme-switcher">
	<span class="material-symbols-rounded theme-switcher__toggle-icon">
		{{ themeIcon }}
	</span>
	Toggle theme
</button>